import * as React from "react";
const SvgBackButton14 = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 8.94 17.35",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("path", {
	d: "M8.17.7.78 8.4a.28.28 0 0 0 0 .4l7.46 7.85",
	"data-name": "Layer 1",
	style: {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeMiterlimit: 10,
		strokeWidth: "1.4px"
	}
})));
export default SvgBackButton14;
